import React from "react";

import { Preview } from "@creatomate/preview";
import { classnames, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { texts } from "app/utils/creatomate-texts.json";

import createElement from "components/stories/video-studio/utils/creatomate/createElement";
import { usePreviewTime } from "components/stories/video-studio/contexts/TimeContext";
import { getEffectColorsByOrg, getOrganizationDefaultFonts } from "components/stories/video-studio/utils";

interface TextOptionsProps {
  preview: Preview;
}

const TextOptions: React.FC<TextOptionsProps> = ({ preview }) => {
  const { time } = usePreviewTime();
  const { profile: { organization } } = useProfile();

  const handleOnSelectTextOption = async (props: any, effects: any, name: string) => {
    let duration;
    if (time + 5 <= (preview.state?.duration || 0)) {
      duration = 5;
    }
    await createElement({
      duration,
      type: "text",
      time,
      ...props,
      ...effects,
      ...getOrganizationDefaultFonts(organization.name || ""),
      ...getEffectColorsByOrg(name, organization.name || "")
    }, preview);
  };

  return (
    <div className="EmptyTextOptions row">
      {texts.filter(text => text.name !== "None").map(text => (
        <div
          className={classnames("TextOption", text.className, text.designWidth === 100 ? "col-xs-12" : "col-xs-6")}
          key={text.name}
        >
          <PlainButton
            onClick={() => handleOnSelectTextOption(text.props, text.effects, text.name)}
          >
            <img className="TextOption-Image" src={text.image_url} alt={text.name} key={text.name} />
          </PlainButton>
        </div>
      ))}
    </div>
  );
};

export default TextOptions;
